import React from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';

import Carousel from '../components/carousel';
import ChecklistAnimated from '../components/checklist-animated';
import DialogButton from '../components/dialogButton';
import FeatureGrid from '../components/feature-grid';
import HeaderBox from '../components/header-box';
import Hero from '../components/hero';
import Layout from '../components/layout';
import SEO from '../components/seo';

import Img from 'gatsby-image';

import '../styles/index.css';

const IndexPage = () => {
    const data = useStaticQuery(graphql`
        query {
            heroBackground: file(
                relativePath: { eq: "background-green-storefront.png" }
            ) {
                childImageSharp {
                    fluid(maxWidth: 2600, jpegQuality: 80) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            map: file(relativePath: { eq: "weave-map.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            responsiveTrio: file(relativePath: { eq: "responsive-trio.png" }) {
                childImageSharp {
                    fluid(maxWidth: 1600, jpegQuality: 80) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="Modern Dispensary Software"
                url="/"
                description="Your modern cannabis dispensary point of sale software. Receive inventory, complete transactions, facilitate compliance, analyze your data, and much more."
            />
            <Hero
                className="index"
                image={data.heroBackground.childImageSharp.fluid}
            >
                <Img
                    className="index-image-container"
                    fluid={data.responsiveTrio.childImageSharp.fluid}
                />
                <div className="index-flex-copy-container">
                    <div>
                        <h1>
                            Modern alternative medicine
                            <br />
                            needs a modern solution
                        </h1>
                        <p>The all-in-one system for cannabis sales.</p>
                    </div>

                    <div className="btns">
                        <DialogButton
                            analyticsValue={3}
                            className="cta"
                            key="talk"
                        >
                            Book Demo
                        </DialogButton>
                        <Link
                            className="explore-btn"
                            key="explore"
                            to="/dispensary-point-of-sale"
                        >
                            <button>Learn More</button>
                        </Link>
                    </div>
                </div>
            </Hero>

            <div className="parallax-section twofer">
                <div className="video-container">
                    <h2>Meet Bre from ShowGrow San Diego!</h2>
                    <p>
                        How ShowGrow streamlined their online ordering to help
                        keep their customers happy and healthy.
                    </p>
                    {/* <HeaderBox
                        copy="How ShowGrow streamlined their online ordering to help keep their customers happy and healthy."
                        header="Meet Bre from ShowGrow San Diego!"
                    /> */}
                    <iframe
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen
                        frameborder="0"
                        height="361"
                        id="index-video-embed"
                        src="https://player.vimeo.com/video/585060429"
                        title="Bre from ShowGrow"
                        width="640"
                    ></iframe>
                </div>

                <ChecklistAnimated
                    header="Weave got you covered"
                    listItems={[
                        { name: 'Full integration with state systems' },
                        { name: 'Seamlessly integrated Online Ordering' },
                        { name: 'Works with your existing hardware' },
                        { name: 'Simple pricing with no contracts' },
                        { name: 'Secure system with 99% uptime' },
                        { name: "Call us – we'll answer" },
                    ]}
                    spaceAbove
                />
            </div>

            <div
                className="parallax-section"
                style={{ backgroundColor: 'white' }}
            >
                <FeatureGrid header="Explore Weave" />
            </div>

            <div className="parallax-section where-we-operate">
                <HeaderBox
                    buttonsList={[
                        <DialogButton analyticsValue={3} key="talk">
                            Grow With us
                        </DialogButton>,
                    ]}
                    copy={[
                        `Weave is available where your cannabis business is located. We currently operate in nine states, and we're continually growing wherever our customers do.`,
                        <br key="yaya"></br>,
                        <br key="yayay"></br>,
                        `We work with small shops to multi-state operators,
                            ensuring your dispensary is compliant with the
                            regulations in your state. Let us navigate the
                            challenges, so you can focus on serving your
                            customers.`,
                    ]}
                    header="We operate where you do"
                />
            </div>

            <div className="parallax-section">
                <Carousel
                    // buttonsList={[<button key="one">I don't know what this button should do</button>]}
                    header="See what people are saying"
                />
            </div>
            {/* <Link to="/page-2/">Go to page 2</Link> */}
        </Layout>
    );
};

export default IndexPage;
